import AccountTemplate from './AccountTemplate.vue';
import { createDomainPortalPanel } from './domain-portal.mjs';
import { createAccountModalAdapter, createBaseLayoutAdapter } from './account-adapter';
import { createAccountPaymentGateways } from './account-payment-gateways';
import { createAccountDashboardSetting } from './account-dashboard-setting';
import { createDashboardDomainsAdapter } from './account-domains-adapter';
import { createAccountSave } from './account-save';
import { createAccountSenderSettingsAdapter } from './account-sender-settings';
import '../styles/account-modal.css';
import '../styles/account-layout.css';

// The shared dashboard template owns the account UI. Package dependencies stay
// local to the consuming app so authentication and settings stores remain intact.
export function createCanonicalAccountModal(LegacyAccountModal, services) {
  const components = { ...LegacyAccountModal.components };
  components.Dropdown = components.Dropdown || components.GdDropdown;
  components.PaymentGateway = createAccountPaymentGateways(components.PaymentGateway, services);
  components.SenderSettings = createAccountSenderSettingsAdapter(components.SenderSettings);
  components.AccountDomains = createDomainPortalPanel(createDashboardDomainsAdapter(components.AccountDomains));
  const canonical = {
    ...LegacyAccountModal,
    components,
    render: AccountTemplate.render,
    staticRenderFns: AccountTemplate.staticRenderFns,
  };
  return {
    ...createAccountModalAdapter(canonical),
    data() { return { accountSaveError: '' }; },
    methods: { update: createAccountSave(services) },
  };
}

// Preserve each application's shell while sharing privileged avatar settings too.
export function createCanonicalBaseLayout({ LegacyBaseLayout, AccountModal, services, name }) {
  const components = { ...LegacyBaseLayout.components };
  components.DashboardSetting = createAccountDashboardSetting(components.DashboardSetting, services);
  return createBaseLayoutAdapter({
    LegacyBaseLayout: { ...LegacyBaseLayout, components },
    AccountModal,
    name,
  });
}
